import Model from 'flarum/Model';
import mixin from 'flarum/utils/mixin';

export default class HeadSlideShow extends mixin(Model, {
  pkgId: Model.attribute('pkgId'),
  transitionTime: Model.attribute('transitionTime'),
  linkOne: Model.attribute('linkOne'),
  imageOne: Model.attribute('imageOne'),
  linkTwo: Model.attribute('linkTwo'),
  imageTwo: Model.attribute('imageTwo'),
  linkThree: Model.attribute('linkThree'),
  imageThree: Model.attribute('imageThree'),
  linkFour: Model.attribute('linkFour'),
  imageFour: Model.attribute('imageFour'),
  linkFive: Model.attribute('linkFive'),
  imageFive: Model.attribute('imageFive'),
  titleOne: Model.attribute('titleOne'),
  titleTwo: Model.attribute('titleTwo'),
  titleThree: Model.attribute('titleThree'),
  titleFour: Model.attribute('titleFour'),
  titleFive: Model.attribute('titleFive'),
  counts: Model.attribute('counts'),

}) {
  apiEndpoint() {
    return '/headSlideShow' + (this.exists ? '/' + this.data.id : '');
  }
}
